import { render } from "./RestaurantDetails.vue?vue&type=template&id=77f8876a&scoped=true&ts=true"
import script from "./RestaurantDetails.vue?vue&type=script&lang=ts"
export * from "./RestaurantDetails.vue?vue&type=script&lang=ts"

import "./RestaurantDetails.vue?vue&type=style&index=0&id=77f8876a&scoped=true&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f8876a"]])

export default __exports__